import React, { useState, useEffect, useRef, useCallback } from 'react';
import { isEmpty } from 'lodash';
import { commonService } from "./API/services";
import GlobalConfig from './API/GlobalConfig/globalConfig';
import Select from 'react-select';

export const HIDDEN_APPROVALS_LIST = [
    "M029_D001_A001",
    "M029_D001_A002",
    "M029_D001_A003",
    "M029_D001_A006",
    "M029_D001_A007",
    "M029_D001_A008",
    "M029_D001_A009",
    "M029_D001_A010",
    "M029_D001_A011",
];
const options = [
    { value: 'allApprovals', label: 'All Approvals' },
    // { value: 'stateApprovals', label: 'State Approval' },
    // { value: 'allSchemes', label: 'Scheme Approvals' }
];
const customStyles = {
    singleValue: (provided) => ({
        ...provided,
        color: "black", // selected value text
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? "#FEF7EF" : "#fff", // optional hover effect
        // color: state.isFocused ? "#F2943B" : "black", // option text
        textAlign: "left",
        cursor: "pointer",
        fontSize: "0.875rem",
        lineHeight: "1.4",
        color: state.isFocused ? "#F2943B" : "rgb(0, 0, 0)",
        transition: "0.3s",
        padding: "12px 20px !important",
        margin: "0px !important",
        fontFamily: "RobotoRegular, sans-serif"
    }),
    input: (provided) => ({
        ...provided,
        color: "black", // typing text
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "black", // placeholder text
    }),
    menu: (provided) => ({
        ...provided,
        width: 300,        // 👈 set fixed width (px, %, or rem)
        minWidth: "100%",  // makes sure it’s not smaller than control
        textAlign: "left"
    }),
};

const GlobalSearch = (props) => {
    const [searchValue, setSearchValue] = useState({});
    const [searchResult, setSearchResult] = useState([]);
    const [approvalList, setApprovalList] = useState([])
    const [selectValue, setSelectValue] = useState('centralApprovals');
    const [showSearchControl, setShowSearchControl] = useState(false)
    const ref = useRef();
    const exploreURL = {
         "centralApprovals": "/portal/approvalsandregistrations"
        // "stateApprovals": "/state-list",
        // "allSchemes": "/government-schemes"
    }
    useEffect(() => {
        getSearchResult();
    }, [selectValue]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setSearchValue({});
                setSearchResult([]);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const closeNav = () => {
        setShowSearchControl(!showSearchControl)
        setSearchValue("");
    }
    const CloseNav = (e) => {
        if (e.which === 13) {
            closeNav()
        }
    }
    const CloseSearchbar = (e) => {
        closeNav()
    }
    const getSearchResult = useCallback(async () => {
        const requestParam = {
            "start": 0,
            "length": 10000,
            "sortBy": "",
            "searchTag": searchValue.global_search || '',
            "filters": {
                "ministry_id": [],
                "department_id": []
            },
        };

        if (selectValue === "centralApprovals") {
            try {
                const response = await commonService.globalSearchData(requestParam);
                const responseData = response.data;
                if (responseData.status === GlobalConfig.MESSAGES_TYPES.TRUE) {
                    setSearchResult(responseData.data);
                    setApprovalList(responseData.data)
                }
            } catch {
                console.log('Error occurred in Central License List');
            }
        }
        // else if (selectValue === "stateApprovals") {
        //     try {
        //         const response = await commonService.globalSearchStateData(requestParam);
        //         const responseData = response.data;
        //         if (responseData.status === GlobalConfig.MESSAGES_TYPES.TRUE) {
        //             setSearchResult(responseData.data);
        //             setApprovalList(responseData.data)
        //         }
        //     } catch {
        //         console.log('Error occurred in State License List');
        //     }
        // }
        // else {
        //     try {
        //         const response = await commonService.globalSearchAllSchemeData(searchValue.global_search);
        //         const responseData = response.data;
        //         if (response.status === 200) {
        //             setSearchResult(responseData);
        //         }
        //     } catch {
        //         console.log('Error occurred in  All Schemes List');
        //     }
        // }
    }, [searchValue, selectValue]);

    const handleChange = (e) => {
        setSelectValue(e.target.value);
        setSearchValue({});
    }


    // const handleChange = (selectedOption) => {
    //     if (!selectedOption) return;

    //     setSelectValue(selectedOption?.value);
    //     setSearchValue({});
    // };


    const searchHandler = (e) => {
        e.persist();
        setSearchValue((previousValue) => {
            return { ...previousValue, [e.target.name]: e.target.value }
        })
        let _searchValue = e.target.value
        let _filterArray = approvalList.filter((item) => (
            item.licenseName.toLowerCase().includes(_searchValue.toLowerCase())
        )
        )
        setSearchResult(_filterArray)
    };

    const searchDetails = (ministryUrl, deptUrl, approvalName, licenseId, schemeUrl, id) => {
        if (selectValue === "allSchemes") {
            window.open(schemeUrl, '_blank')
        }
        else {
            localStorage.setItem('approvalsId', licenseId);
            window.open(`${"/portal/approval-details"}/${ministryUrl}/${deptUrl}/${approvalName}`, '_blank')
        }
    };
    const SearchDetails = (e, ministryUrl, deptUrl, approvalName, licenseId, schemeUrl, id) => {
        if (e.which === 13) {
            searchDetails(ministryUrl, deptUrl, approvalName, licenseId, schemeUrl, id)
        }
    };

    const removeApproval = (searchResult) => {
        const result = searchResult && searchResult.filter((searchItem) => {
            return HIDDEN_APPROVALS_LIST.includes(searchItem?.referenceId)
        });
        if (!isEmpty(result) || searchResult?.length === 0) {
            return <li className="no-data-react">No data found.</li>
        } else {
            return (searchResult && searchResult.map((searchItem, index) => (
                HIDDEN_APPROVALS_LIST.includes(searchItem?.referenceId) ? null :
                    <li tabIndex="0" key={index}
                        onClick={() => searchDetails(
                            searchItem?.ministryUrlTitle || searchItem?.stateUrlTitle,
                            searchItem?.departmentUrlTitle || searchItem?.authorityUrlTitle,
                            searchItem?.urlTitle,
                            searchItem?.licenseId,
                            searchItem?.schemeUrl,
                            searchItem.licenseId
                        )}
                        onKeyDown={
                            (e) =>
                                SearchDetails(
                                    e,
                                    searchItem?.ministryUrlTitle || searchItem?.stateUrlTitle,
                                    searchItem?.departmentUrlTitle || searchItem?.authorityUrlTitle,
                                    searchItem?.urlTitle,
                                    searchItem?.licenseId,
                                    searchItem?.schemeUrl,
                                    searchItem.licenseId

                                )}>
                        {searchItem?.policyName || searchItem.licenseName}
                    </li>
            )))
        }
    };

    return (
        <div className="search-container-react" ref={ref}>
            <div className="search-icon-react" tabIndex="0" onKeyDown={(e) => CloseNav(e)} onClick={closeNav}>
                <i>
                    {!showSearchControl && !props.CenterSearch ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 13 13.001">
                            <g id="Group_832" transform="translate(-1197 -58.508)">
                                <path id="Op_component_1" d="M1044.725 71.508a5.726 5.726 0 1 0 5.725 5.725 5.732 5.732 0 0 0-5.725-5.725zm0 10.394a4.669 4.669 0 1 1 4.668-4.669 4.674 4.674 0 0 1-4.668 4.667z" className="cls-1" transform="translate(158 -13)"></path>
                                <path id="Op_component_2" d="M1051.845 83.607l-3.03-3.03a.528.528 0 1 0-.747.747l3.03 3.03a.528.528 0 1 0 .747-.747z" className="cls-1" transform="translate(158 -13)"></path>
                            </g>
                        </svg>
                        :
                        <span className='search-close-react'></span>
                    }
                </i>
            </div>
            {
                (showSearchControl || props?.CenterSearch) &&
                <div className={props?.CenterSearch ? "search-box-react" : "header-search-box-react"}>
                    <div className={props?.CenterSearch ? "search-filter-react" : "header-search-filter-react"}>
                        <div className="homepage-approvals-search-react">
                            {/* <Select options={options} defaultValue={options[0]} onChange={handleChange} value={options.filter((opt) => opt.value === selectValue)?.[0]} isSearchable={false} styles={customStyles} /> */}

                            <Select
                                    options={options}
                                    value={options[0]}                                
                                    isSearchable={false}
                                    menuIsOpen={false} // Prevent dropdown opening
                                    styles={customStyles}
                            />

                            <div className="search-form-container-react">
                                <input
                                    placeholder="Search Approvals"
                                    className="search-input-control-react approvals-search-box-react"
                                    name="global_search"
                                    value={searchValue.global_search || ''}
                                    onChange={searchHandler}
                                    autoComplete="off"
                                    autoFocus={true}
                                />
                                {
                                    searchValue?.global_search?.length > 0 &&
                                    <ul className="search-list-container-react">
                                        {
                                            removeApproval(searchResult)
                                        }
                                    </ul>
                                }
                            </div>
                        </div>
                        <a href={exploreURL[selectValue]} target="_blank" className="button-green-react" tabIndex="0" onKeyDown={(e) => CloseSearchbar(e)}>
                            <span>Explore All</span>
                        </a>
                    </div>

                </div>
            }
        </div>
    )
};

export default GlobalSearch;
